export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/laurel-profile-a041feed17205aa23ec01657ede0fae1.png";